module.exports = ".text {\n  margin-bottom: 2em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/checkout-components/complete-payment/complete-payment.presentation.scss
// module id = QfSd
// module chunks = 12